import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const contractMutations: UpdatesConfig['Mutation'] = {
  contractCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('contracts', cache);
  },
  contractDelete: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('contracts', cache);
  },
};

export default contractMutations;
